// src/components/SmartAlertFAQ.jsx
import React from "react";

const SmartAlertFAQ = () => {
  const faqs = [
    {
      q: "What is Smart Alert?",
      a:
        "Smart Alert lets you send an alert to your saved trusted contacts. When triggered, it can include your custom message, available location information, and basic profile information to help identify the sender.",
    },
    {
      q: "Is Smart Alert a replacement for emergency services?",
      a:
        "No. Smart Alert is not a replacement for 911, police, fire, ambulance, campus safety, school safety, or local emergency services. In a real emergency, contact emergency services directly whenever possible.",
    },
    {
      q: "What is the difference between Test Mode and Live Mode?",
      a:
        "Test Mode is used to test the Smart Alert workflow. Live Mode is the real alert mode where an alert may be sent to your saved contacts. Always test your setup before relying on Live Mode.",
    },
    {
      q: "What happens when I press and hold the button?",
      a:
        "A short countdown starts. If you continue holding until the countdown completes, Smart Alert attempts to send the alert using your saved settings and available account information.",
    },
    {
      q: "What information may be sent with an alert?",
      a:
        "An alert may include your custom message, available location information, and profile information that helps identify the sender, such as the sender’s saved profile details. The exact information depends on your account settings and available permissions.",
    },
    {
      q: "How does location sharing work?",
      a:
        "If location sharing is enabled and available, Smart Alert attempts to include your most recent available location. Location may be approximate, delayed, unavailable, or based on the last cached location depending on your device, browser, permissions, and network.",
    },
    {
      q: "What does Stealth Mode do?",
      a:
        "Stealth Mode controls whether the button uses sound and vibration during the countdown. When Stealth Mode is on, Smart Alert avoids the beep/vibration feedback so the action is more discreet.",
    },
    {
      q: "What do the button colors mean?",
      a:
        "Amber means Test Mode. Red means Live Mode, where a real alert may be sent. A darker red or blocked/error message means the alert cannot complete until the issue is fixed, such as login, contact, quota, or backend problems.",
    },
    {
      q: "Can I edit my contacts later?",
      a:
        "Yes. You can update saved contacts, email addresses, phone numbers, and custom messages from Smart Alert settings.",
    },
    {
      q: "Why do I see Required Login, Error, or another blocked message?",
      a:
        "This usually means Smart Alert cannot complete the action yet. You may need to log in, add contacts, enable required permissions, resolve a quota or account issue, or try again after a temporary service problem.",
    },
  ];

  return (
    <div style={styles.wrapper}>
      <div style={styles.header}>
        <h3 style={styles.title}>Frequently Asked Questions</h3>
        <p style={styles.subtitle}>
          A quick guide to how Smart Alert works, what gets sent, and what each mode means.
        </p>
      </div>

      <div style={styles.list}>
        {faqs.map((item, i) => (
          <article key={i} style={styles.item}>
            <div style={styles.questionRow}>
              <span style={styles.number}>{i + 1}</span>
              <strong style={styles.question}>{item.q}</strong>
            </div>
            <p style={styles.answer}>{item.a}</p>
          </article>
        ))}
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    width: "100%",
    maxWidth: 720,
    margin: "0 auto",
    padding: "2px 0 4px",
    boxSizing: "border-box",
    fontFamily: "sans-serif",
  },
  header: {
    marginBottom: 12,
    textAlign: "center",
  },
  title: {
    margin: 0,
    color: "#0F172A",
    fontSize: 20,
    lineHeight: 1.25,
    fontWeight: 950,
    letterSpacing: "-0.25px",
  },
  subtitle: {
    margin: "7px auto 0",
    maxWidth: 560,
    color: "#64748B",
    fontSize: 13.5,
    lineHeight: 1.5,
    fontWeight: 650,
  },
  list: {
    display: "grid",
    gap: 10,
  },
  item: {
    padding: "14px 15px",
    borderRadius: 16,
    border: "1px solid rgba(2,6,23,0.10)",
    background: "#FFFFFF",
    boxShadow: "0 10px 24px rgba(2,6,23,0.045)",
  },
  questionRow: {
    display: "grid",
    gridTemplateColumns: "32px minmax(0, 1fr)",
    gap: 10,
    alignItems: "center",
  },
  number: {
    width: 28,
    height: 28,
    borderRadius: 10,
    background: "rgba(37,99,235,0.10)",
    color: "#2563EB",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12.5,
    fontWeight: 950,
  },
  question: {
    color: "#0F172A",
    fontSize: 14.5,
    lineHeight: 1.35,
    fontWeight: 950,
  },
  answer: {
    margin: "9px 0 0 42px",
    color: "#334155",
    fontSize: 13.5,
    lineHeight: 1.58,
    fontWeight: 650,
  },
};

export default SmartAlertFAQ;
